import { PropsWithChildren, useMemo } from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  danger?: boolean
  sm?: boolean
  withIcon?: boolean
}

export const Button = (props: PropsWithChildren<Props>) => {
  const { type = 'button', className } = props
  const { danger, children, sm, withIcon, ...buttonProps } = props

  const twClasses = useMemo(() => {
    const bg = danger
      ? 'bg-red-700 hover:bg-red-400 disabled:bg-red-200'
      : 'bg-primary-400 hover:bg-primary-300 disabled:bg-primary-200'

    let padding = 'py-2 px-4'
    if (sm) {
      padding = 'py-1.5 px-3'
    }
    if (withIcon) {
      padding = 'py-1 px-2'
    }

    const fontSize = sm ? 'text-[0.7rem]' : 'text-[0.9rem]'

    return `${bg} ${padding} ${fontSize} ${className || ''}`
  }, [danger, withIcon, sm, className])

  return (
    <button
      {...buttonProps}
      type={type}
      className={`${twClasses} rounded inter font-medium text-white transition-colors duration-100`}
    >
      {children}
    </button>
  )
}
